<template>
    <div>
        <common-content-spacer height="medium">
            <discounts-list
                :discountsList="discountsList"
                :offers="offers"
                @discounts-changed="onDiscountChanged"
            ></discounts-list>
        </common-content-spacer>
    </div>
</template>

<script>
    import DiscountsList from 'components/page-elements/offer/DiscountsList.vue'
    import OfferAPI from 'api/OfferAPI'

    export default {
        components: {
            DiscountsList,
        },
        props: {
            offers: { type: Array, required: true },
        },
        data() {
            return {
                totalCount: 10,
                discountsList: [],
            }
        },

        provide() {
            return {
                isCompany: !!this.$route.params.id,
            }
        },

        methods: {
            onDiscountChanged() {
                this.getDiscounts()
            },

            getDiscounts() {
                if (this.$route.params.id) {
                    OfferAPI.getCompanyDiscounts(this.$route.params.id).then((response) => {
                        this.discountsList = response
                    })
                } else {
                    OfferAPI.getUserDiscounts().then((response) => {
                        this.discountsList = response
                    })
                }
            },
        },

        mounted() {
            this.getDiscounts()
        },
    }
</script>
